import {
  ParagraphText,
  StackLayout,
  TextAction,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { INTERNAL_LINKS } from 'common/links';

export const SignInFooter = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ width: '100%', gap: '$two' }}
    >
      <StackLayout horizontalAlignment="center" css={{ gap: '$none' }}>
        <UtilityText>
          {formatMessage({ id: 'STR_LANDING_PAGE_DONT_HAVE_ACCOUNT' })}
        </UtilityText>
        <TextAction
          href={APP_MANAGED_ROUTES.SIGN_IN}
          css={{
            textDecoration: 'underline',
          }}
          size="medium"
        >
          {formatMessage({ id: 'STR_LANDING_PAGE_REGISTER_NOW' })}
        </TextAction>
      </StackLayout>
      <TextAction
        href={APP_MANAGED_ROUTES.SIGN_IN}
        size="medium"
        css={{
          textDecoration: 'underline',
        }}
      >
        {formatMessage({ id: 'STR_LANDING_PAGE_FORGOT_PASSWORD' })}
      </TextAction>
      <ParagraphText size="sm">
        <TextAction
          href={INTERNAL_LINKS.POLICY}
          size="medium"
          css={{
            fontWeight: '$bodyOne !important',
          }}
        >
          {formatMessage({ id: 'STR_PRIVACY_POLICY' })}
        </TextAction>
        {` ${formatMessage({ id: 'STR_AND' })} `}
        <TextAction
          href={INTERNAL_LINKS.TERMS}
          emphasis="subtle"
          size="medium"
          css={{
            fontWeight: '$bodyOne !important',
          }}
        >
          {formatMessage({ id: 'STR_TERMS_OF_SERVICE' })}
        </TextAction>
      </ParagraphText>
    </StackLayout>
  );
};
